import { Action } from '../../actions/actions';
import { ModalOptions } from './types';

export interface ModalTree {
  open?: {
    name: string;
    options: ModalOptions;
  };
}

export const initialModalState: ModalTree = {};

export function reducer(state = initialModalState, action: Action): ModalTree {
  switch (action.type) {
    case 'MODAL/OPEN':
      return {
        open: {
          ...action.payload,
        },
      };
    case 'MODAL/CLOSE':
      if (state.open && state.open.name === action.payload.name) {
        return {};
      }

      return state;
    case 'MODAL/UPDATE':
      if (state.open) {
        return {
          open: {
            ...state.open,
            options: {
              ...state.open.options,
              ...action.payload.options,
            },
          },
        };
      }
      return state;
  }
  return state;
}
